import { consumeAPI2, consumePostAPI2, consumeDeleteAPI2, consumePostAPI3 } from '../apiClient';
import { buildFilter } from '../../services/utils/leads';

// Devuelve listado de actions filters
export async function getActionsLeads() {
  const url = `/publisher/leads/filters`;
  return consumeAPI2(url);
}

export async function markLeadStatus(status, contactIds, reason) {
  const url = `/leads/status/${status}?${buildFilter('contact_publisher_user_id', contactIds)}${buildFilter(
    'reason',
    reason
  )}`;
  return consumePostAPI2(url).toPromise();
}

export async function sendMessages(leadId, message, isComment, leadMessageAttachments) {
  const url = `/leads/${leadId}/messages`;
  return consumePostAPI2(url, {
    message,
    is_comment: isComment,
    message_attachments: leadMessageAttachments
  }).toPromise();
}

export async function Upload(form) {
  const url = `/leads/upload`;
  return consumePostAPI3(url, form).toPromise();
}

export async function getSmartLead(contactPublisherUserId) {
  const url = `/publisher/contact/${contactPublisherUserId}/smartlead`;
  return consumeAPI2(url).toPromise();
}

export async function sendFeedbackEmail(leadId) {
  const url = `/feedback/sendFeedbackEmail/${leadId}`;
  return consumePostAPI2(url).toPromise();
}

export async function getUserProfle(contactPublisherUserId) {
  const url = `/publisher/contact/${contactPublisherUserId}/user-profile`;
  return consumeAPI2(url).toPromise();
}

export async function getSmartLeadEmail(email) {
  const url = `/publisher/leads/validation/email/${email}`;
  return consumeAPI2(url).toPromise();
}

export async function getMessageAttachements(contactPublisherUserId) {
  const url = `/leads/${contactPublisherUserId}/message_attachements`;
  return consumeAPI2(url).toPromise();
}

export async function getScoringLead(contactPublisherUserId) {
  const url = `/publisher/leads/scoring/${contactPublisherUserId}`;
  return consumeAPI2(url).toPromise();
}

export async function getRenterProfile(contactPublisherUserId) {
  const url = `/publisher/contact/${contactPublisherUserId}/renter-profile`;
  return consumeAPI2(url).toPromise();
}

export async function getCustomAnswers() {
  const url = `/custom-answer`;
  return consumeAPI2(url).toPromise();
}

export async function postCustomAnswer(customAnswer) {
  const url = `/custom-answer/add-answer`;
  return consumePostAPI2(url, customAnswer).toPromise();
}

export async function postCustomAnswerList(customAnswer) {
  const url = `/custom-answer/add-all-answers`;
  return consumePostAPI2(url, customAnswer).toPromise();
}

export async function deleteCustomAnswers(customAnswerId) {
  const url = `/custom-answer/${customAnswerId}`;
  return consumeDeleteAPI2(url).toPromise();
}

export async function getSmartLeadPhone(phone) {
  const url = `/publisher/leads/validation/phone/${phone}`;
  return consumeAPI2(url).toPromise();
}

export async function getChatMessages(contactPublisherUserId) {
  const url = `/leads/${contactPublisherUserId}/chat`;
  return consumeAPI2(url).toPromise();
}

export async function getOtherConsult(contactPublisherUserId) {
  const url = `/publisher/leads/${contactPublisherUserId}/related`;
  return consumeAPI2(url).toPromise();
}

export async function getContactInfo(contactPublisherUserId) {
  const url = `/publisher/contact/${contactPublisherUserId}`;
  return consumeAPI2(url).toPromise();
}
